var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationIcon = function SvgLocationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FAC532",
    fillRule: "evenodd",
    d: "M3.7 2.534a4.667 4.667 0 0 1 7.967 3.3c0 1.807-1.176 3.56-2.466 4.921A17 17 0 0 1 7 12.701a17.178 17.178 0 0 1-2.202-1.946C3.51 9.395 2.333 7.641 2.333 5.833c0-1.237.492-2.424 1.367-3.3m2.976 11.368L7 13.417zc.196.13.452.13.648 0L7 13.417l.324.485.002-.001.003-.003.014-.009.048-.033q.063-.043.176-.125a18.325 18.325 0 0 0 2.481-2.174c1.336-1.41 2.785-3.448 2.785-5.724a5.833 5.833 0 0 0-11.666 0c0 2.276 1.449 4.315 2.784 5.724a18.3 18.3 0 0 0 2.658 2.299l.048.033.014.01.003.002zm-.843-8.069a1.167 1.167 0 1 1 2.334 0 1.167 1.167 0 0 1-2.334 0M7 3.5a2.333 2.333 0 1 0 0 4.667A2.333 2.333 0 0 0 7 3.5",
    clipRule: "evenodd"
  })));
};
export default SvgLocationIcon;